import React from 'react';
import { classNameBuilder } from '../../utils/className';

import './Button.scss';
import { SpinnerIcon } from '../../assets/icons/svgIconsForJSX';

interface IProps {
    scheme?: 'light' | 'dark';
    variant?: 'contain' | 'outline';
    type?: 'button' | 'submit' | 'reset';
    fullWidth?: boolean;
    disabled?: boolean;
    loading?: boolean;
    width?: 'auto' | 'small' | 'medium' | 'large' | 'long';
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    border?: 'solid' | 'none' | 'dark';
    className?: string;
}

const Button: React.FC<React.PropsWithChildren<IProps>> = ({
    scheme = 'dark',
    variant = 'contain',
    type = 'button',
    fullWidth = false,
    disabled = false,
    loading = false,
    width = 'small',
    onClick,
    children,
    border = 'none',
    className = '',
}) => {
    const cn = classNameBuilder('button');

    return (
        <button
            type={type}
            disabled={disabled || loading}
            onClick={onClick}
            className={`${cn({
                type: `${variant}-${scheme}`,
                fullWidth,
                width: width,
                border: border,
            })}  ${className}`}>
            {loading ? <SpinnerIcon /> : null}
            <span>{children}</span>
        </button>
    );
};

export default Button;
